<template>
    <div v-if="label" class="mt-5 ml-5">
        <v-btn color="primary" depressed large @click="showSearch">
            {{label}}
            <v-icon small class="ml-3">fas fa-search</v-icon>
        </v-btn>
    </div>
    <div v-else>
        <v-btn small text fab @click="showSearch">
            <v-icon small>fas fa-search</v-icon>
        </v-btn>
    </div>
</template>
<script>
export default {
    name: "QSearch",
    props: [
        'label'
    ], // data passed to component from parent
    data: function() { // data internal to component (not available outside)
        return {
            active: false,
            timeout_close: null,
            keywords: '',
        }
    },
    mounted: function() {

    },
    computed: {

    },
    methods: {
        showSearch: function() {
            this.$store.commit('updateShowSearch', true)
        },
        performSearch: function(e) {
            if (e.keyCode === 13) {
                this.active = false;
                this.$router.push({ name: 'SearchResults', query: { keyword: this.keywords } }).catch(err => { g.showError("Whoops! " + err) })
            }
        }
    },
    watch: {

    },
}

</script>
<style scoped>
</style>
